module.exports = __webpack_public_path__ + "images/banners/question/hikakaku_q_banner_pc_1fc6593f034557e7b3686ed762d1ef51.png";